module.exports = {
  blogPostDir: "posts", // The name of directory that contains your posts.
  lessonsDir: "lessons", // The name of the directory that contains lessons or docs.
  siteTitle: "Mining Act Awareness Program", // Site title.
  siteTitleAlt: "Mining Act Awareness Program (MAAP)", // Alternative site title for SEO.
  siteLogo: "/maapp/en/logos/ontario.png", // Logo used for SEO and manifest.
  siteUrl: "https://www.mlas.mndm.gov.on.ca", // Domain of your website without pathPrefix.
  pathPrefix: "/maapp/en", // Prefixes all links. For cases when deployed to example.github.io/gatsby-advanced-starter/.
  siteDescription: "Interactive Mining Act Awareness Program", // Website description used for RSS feeds/meta description tag.
  siteRss: "/rss.xml", // Path to the RSS file.
  siteFBAppID: "x1825356251115265x", // FB Application ID for using app insights
  googleAnalyticsID: "xUA-82450300-1x ", // GA tracking ID.
  disqusShortname: "xhttps-ericwindmill-github-io-gatsby-advanced-starter", // Disqus shortname.
  postDefaultCategoryID: "MAAP", // Default category for posts.
  userName: "User", // Username to display in the author segment.
  // userTwitter: "user", // Optionally renders "Follow Me" in the UserInfo segment.
  userLocation: "Sudbury, ON", // User location to display in the author segment.
  userAvatar: "/logos/ontario.png", // User avatar to display in the author segment.
  userDescription: "about", // User description to display in the author segment.
  // Links to social profiles/projects you want to display in the author segment/navigation bar.
  userLinks: [
    {
      label: "GitHub",
      url: "https://github.com/ontario-digital",
      iconClassName: "fa fa-github"
    },
    // {
    //   label: "Twitter",
    //   url: "https://twitter.com/OntarioMNDM",
    //   iconClassName: "fa fa-twitter"
    // },
    /* {
      label: "Messenger",
      url: "https://www.messenger.com/t/eric.windmill",
      iconClassName: "fa fa-message"
    }, */
    {
      label: "Email",
      url: "mailto:ndmminister@ontario.ca",
      iconClassName: "fa fa-envelope"
    }/* ,
    {
      label: "Instagram",
      url: "https://instagram.com/ericwindmill",
      iconClassName: "fa fa-envelope"
    } */
  ],
  copyright: "Copyright © QUEEN'S PRINTER FOR ONTARIO, 2018", // Copyright string for the footer of the website and RSS feed.
  themeColor: "#c62828", // Used for setting manifest and progress theme colors.
  backgroundColor: "#e0e0e0", // Used for setting manifest background color.
  // TODO: Move this literally anywhere better.
  // Used to generate the Table Of Contents. Index 0 should be blank.
  //toCChapters: ["", "Introduction", "Before Registering a Mining Claim", "Keeping a Mining Claim in Good Standing", "Early Exploration", "Advancing through the Mining Sequence"] 
  toCChapters: ["", "Introduction", "Before Registering a Mining Claim", "Registering a Mining Claim", "Performing Work on Mining Lands - Early Exploration Activities", "Keeping a Mining Claim in Good Standing - Assessment Work", "Advancing Through The Mining Sequence", "Complete MAAP"] 
};



// WEBPACK FOOTER //
// ./data/SiteConfig.js